import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ManualVoucherApprovalCard } from '@/entities/manual-voucher-approval'

export const Route = createFileRoute(
  '/_auth/applications/manual-voucher-approval/$manualVoucherId/common'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <ManualVoucherApprovalCard />
      <Outlet />
    </>
  )
}
